<template>
    <div class="search-filter__container">
        <div ref="filterWrapper" class="search-panel__filter">
            <div class="search-panel__filter-form-wrapper">
                <form ref="form" action="/" method="post" class="search-panel__filter-form" @change="emitSend">
                    <div :class="['search-panel__filter-item']"
                         v-for="(filter, index) in filters"
                         :key="index">
                        <div class="search-panel__filter-title">{{ filter.label }}</div>
                        <template v-if="isCheckboxFilter(filter.type)">
                            <div class="search-panel__form-input">
                                <CheckboxItem
                                    v-for="item in filter.items"
                                    :key="item.id"
                                    :title="item.title"
                                    :name="`${filter.category}[${item.id}]`"
                                    :value="`${item.id}`"
                                    :checked="item.checked"
                                    :disabled="item.disabled"
                                    modify="checkbox_theme_block" />
                            </div>
                        </template>
                        <template v-if="isSliderFilter(filter.type)">
                            <RangeSlider :slider="filter"
                                         :translations="data.settings.translations.form"
                                         @change="emitSend"/>
                        </template>
                    </div>
                    <ResultButton v-if="!isEmpty(link)"
                                  :link="link"
                                  :windowWidth="windowWidth" />
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import CheckboxItem from '../CheckboxItem/CheckboxItem.vue';
import CloseIcon from '../media/close-icon.vue';
import RangeSlider from '../RangeSlider/RangeSlider.vue';
import ResultButton from '../ResultButton/ResultButton.vue';
import SearchIcon from '../media/search-icon.vue';
import {Utils} from '../../../common/scripts/utils';

export default {
    props: ['data', 'windowWidth'],

    data() {
        return {
            isFixed: false
        };
    },

    components: {
        CheckboxItem,
        CloseIcon,
        RangeSlider,
        ResultButton,
        SearchIcon
    },

    computed: {
        filters() {
            return this.data.filters || null;
        },

        link() {
            return this.data.link || null;
        }
    },

    watch: {
        isPanelOpen() {
            if (this.isPanelOpen) {
                if (this.isMobile) {
                    Utils.bodyFixed(this.$refs.filterWrapper);
                    this.isFixed = true;
                } else if (this.isFixed) {
                    Utils.bodyStatic();
                }
            } else if (this.isMobile) {
                Utils.bodyStatic();
                this.isFixed = false;
            }
        },

        isMobile() {
            if (this.isFixed) {
                Utils.bodyStatic();
                this.isFixed = false;
            }
        }
    },

    methods: {
        toggleFilter() {
            if (this.isPanelOpen) {
                this.closeFilter();
            } else {
                this.openFilter();
            }
        },

        openFilter() {
            this.$emit('openFilter');
        },

        closeFilter() {
            this.$emit('closeFilter');
        },

        /**
         * При изменении фильтра,
         * отправляем данные на бэк
         */
        emitSend() {
            this.$emit('changeFilter', this.$refs.form);
        },

        /**
         * Проверяет объект на пустоту
         * @param {Object} obj - проверяемый объект
         * @return {boolean|boolean} - true, если пустой
         */
        isEmpty(obj) {
            if (!obj) {
                return true;
            }

            return Object.keys(obj).length === 0 && obj.constructor === Object;
        },

        isCheckboxFilter(type) {
            return type === 'checkbox';
        },

        isSliderFilter(type) {
            return type === 'slider';
        },

        isSelectFilter(type) {
            return type === 'select';
        }
    }
};
</script>
